module.exports = __webpack_public_path__ + "img/multiplier_128.59f4f453.png";